
const digest = '92106e698bf3c8b2a2bfa4c90ba8ae8d811fc5ed87943f1999e1e8d2d540649c';
const classes = {"item":"_item_1k5cb_1","title":"_title_1k5cb_17"};
const css = `._item_1k5cb_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-top: 1px solid #eaedf3;
  padding: 20px 0;
  align-items: center;
  gap: 10px;
}
._item_1k5cb_1:first-of-type {
  border-top: 0;
}
._item_1k5cb_1:last-of-type {
  border-bottom: 1px solid #eaedf3;
}
._item_1k5cb_1 ._title_1k5cb_17 {
  font-size: 14px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  